export default "__VITE_ASSET__eV_erEk$__"